/** The words the family uses for where money comes from (skill 13). */
import type { IncomeSourceType, StabilityClass } from '@pfo/domain';

export const INCOME_SOURCE_TYPE_LABELS: Record<IncomeSourceType, string> = {
  salary: 'Lương',
  bonus: 'Thưởng',
  creator: 'Sáng tạo nội dung',
  freelance: 'Làm thêm',
  business: 'Kinh doanh',
  crypto: 'Crypto',
  investment: 'Đầu tư',
  interest: 'Lãi tiền gửi',
  dividend: 'Cổ tức',
  rental: 'Cho thuê',
  gift: 'Được tặng',
  other: 'Khác',
};

/**
 * How much of this income can be planned on. This is not decoration: `safe_to_invest` is
 * built on stable flows only, so mislabelling a one-off bonus as salary inflates what the
 * app says is safe to invest (B10, step 1.7).
 */
export const STABILITY_CLASS_LABELS: Record<StabilityClass, string> = {
  stable: 'Ổn định hằng tháng',
  semi_stable: 'Khá ổn định',
  variable: 'Thay đổi thất thường',
  one_off: 'Chỉ một lần',
};
